import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <a href="mailto:support@myschedulepal.com" className={styles.footerLink}>
          Contact Support
        </a>
        <span className={styles.divider}>•</span>
        <a 
          href="https://myschedulepal.com/tos" 
          target="_blank" 
          rel="noreferrer"
          className={styles.footerLink}
        >
          Privacy Policy
        </a>
        <span className={styles.divider}>•</span>
        <a 
          href="https://myschedulepal.com/tos" 
          target="_blank" 
          rel="noreferrer"
          className={styles.footerLink}
        >
          Terms of Service
        </a>
      </div>
    </footer>
  );
};

export default Footer;